function UserMeedyVO(id, login, email, firstName, lastName, roles, partnerType, passwordExpired, passwordLastChangeDate, name, phone, status, medicalPost, resources, pictureUrl, inEdm, contractAcceptation, pwz, saneoCooperation) {

    this.id = id;
    this.login = login;
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
    this.passwordLastChangeDate = passwordLastChangeDate;
    this.roles = roles;
    this.partnerType = partnerType;
    this.passwordExpired = passwordExpired;
    this.name = name;
    this.phone = phone;
    this.status = status;
    this.medicalPost = medicalPost;
    this.resources = resources;
    this.pictureUrl = pictureUrl;
    this.inEdm = inEdm === true;
    this.contractAcceptation = contractAcceptation === true;
    this.pwz = pwz;
    this.saneoCooperation = saneoCooperation;

    var _typeContext = {
        passwordLastChangeDate: Date,
        roles: RoleMeedyVO,
        medicalPost: MedicalPostMeedyVO,
        resources: ResourceMeedyVO,
        status: StatusReasonMeedyVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
